module.exports = __webpack_public_path__ + "img/hero-machine.476c6d09.png";